import { toast } from 'react-toastify';
import {
  Inviter,
  Registerer,
  RegistererState,
  SessionState,
  UserAgent
} from 'sip.js';
import newCallAudio from '../../../../../assets/audios/newCall.mp3';
import toneCallAudio from '../../../../../assets/audios/toneCall.mp3';
import endCallAudio from '../../../../../assets/audios/endCall.mp3';
import { ServiceCRUDBACKEND } from 'services/ServiceCRUDBACKEND';

class UserAgentSingleton {
  constructor() {
    this.isCallInProgress = false;
    this.selectedInputDevice =
      localStorage.getItem('softphone_selected_input_device') || '';
    this.selectedOutputDevice =
      localStorage.getItem('softphone_selected_output_device') || '';
    this.inputVolume =
      parseFloat(localStorage.getItem('softphone_input_volume')) || 1.0;
    this.outputVolume =
      parseFloat(localStorage.getItem('softphone_output_volume')) || 1.0;
  }

  setInputDevice(deviceId) {
    console.log(`[UserAgent] setInputDevice chamado com: ${deviceId}`);
    console.log(
      `[UserAgent] Dispositivo anterior: ${this.selectedInputDevice}`
    );

    this.selectedInputDevice = deviceId;
    localStorage.setItem('softphone_selected_input_device', deviceId);
    console.log(`[UserAgent] Dispositivo de entrada atualizado: ${deviceId}`);
    console.log(`[UserAgent] Sessão ativa:`, !!this.session);

    this.applyInputDeviceToCurrentStream();
  }
  setOutputDevice(deviceId) {
    this.selectedOutputDevice = deviceId;
    localStorage.setItem('softphone_selected_output_device', deviceId);
    console.log(`[UserAgent] Dispositivo de saída atualizado: ${deviceId}`);

    if (this.mediaElement) {
      this.applyOutputDeviceToElement(this.mediaElement);
    }
  }

  async applyOutputDeviceToElement(audioElement) {
    if (!audioElement || !this.selectedOutputDevice) return false;

    if (typeof audioElement.setSinkId === 'function') {
      try {
        await audioElement.setSinkId(this.selectedOutputDevice);
        console.log(
          `[UserAgent] Dispositivo de saída aplicado: ${this.selectedOutputDevice}`
        );
        return true;
      } catch (error) {
        console.error(
          '[UserAgent] Erro ao aplicar dispositivo de saída:',
          error
        );
        return false;
      }
    } else {
      console.warn('[UserAgent] setSinkId não suportado no navegador');
      return false;
    }
  }

  getMediaConstraints() {
    const baseConstraints = {
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true
      },
      video: false
    };

    if (this.selectedInputDevice && this.selectedInputDevice !== 'default') {
      baseConstraints.audio.deviceId = { exact: this.selectedInputDevice };
    }

    return baseConstraints;
  }

  setInputVolume(volume) {
    this.inputVolume = Math.max(0, Math.min(1, volume));
    localStorage.setItem('softphone_input_volume', this.inputVolume.toString());
    console.log(
      `[UserAgent] Volume de entrada: ${Math.round(this.inputVolume * 100)}%`
    );

    this.applyInputVolumeToCurrentStream();
  }

  setOutputVolume(volume) {
    this.outputVolume = Math.max(0, Math.min(1, volume));
    localStorage.setItem(
      'softphone_output_volume',
      this.outputVolume.toString()
    );
    console.log(
      `[UserAgent] Volume de saída: ${Math.round(this.outputVolume * 100)}%`
    );

    if (this.mediaElement) {
      this.mediaElement.volume = this.outputVolume;
    }
  }

  applyInputVolumeToCurrentStream() {
    if (this.session && this.session.sessionDescriptionHandler) {
      const pc = this.session.sessionDescriptionHandler.peerConnection;
      if (pc) {
        pc.getSenders().forEach((sender) => {
          if (sender.track && sender.track.kind === 'audio') {
            if (!this.gainNode && window.AudioContext) {
              try {
                this.audioContext = new (window.AudioContext ||
                  window.webkitAudioContext)();
                this.gainNode = this.audioContext.createGain();
                this.gainNode.gain.value = this.inputVolume;
              } catch (error) {
                console.warn(
                  '[UserAgent] Não foi possível criar contexto de áudio:',
                  error
                );
              }
            } else if (this.gainNode) {
              this.gainNode.gain.value = this.inputVolume;
            }
          }
        });
      }
    }
  }

  async applyInputDeviceToCurrentStream() {
    console.log(`[UserAgent] applyInputDeviceToCurrentStream chamado`);
    console.log(
      `[UserAgent] Dispositivo selecionado: ${this.selectedInputDevice}`
    );
    console.log(`[UserAgent] Sessão ativa:`, !!this.session);

    if (!this.session || !this.session.sessionDescriptionHandler) {
      console.log(
        '[UserAgent] Não há sessão ativa, dispositivo será usado na próxima chamada'
      );
      return;
    }

    try {
      console.log(
        `[UserAgent] Aplicando novo dispositivo de entrada: ${this.selectedInputDevice}`
      );

      const constraints = this.getMediaConstraints();
      console.log('[UserAgent] Constraints para novo stream:', constraints);

      const newStream = await navigator.mediaDevices.getUserMedia(constraints);
      console.log('[UserAgent] Novo stream obtido:', newStream);

      const audioTrack = newStream.getAudioTracks()[0];
      if (audioTrack) {
        console.log('[UserAgent] Novo track de áudio:', audioTrack.label);

        const pc = this.session.sessionDescriptionHandler.peerConnection;
        const sender = pc
          .getSenders()
          .find((s) => s.track && s.track.kind === 'audio');

        if (sender) {
          console.log('[UserAgent] Substituindo track de áudio...');
          await sender.replaceTrack(audioTrack);
          console.log(
            '[UserAgent] Dispositivo de entrada aplicado com sucesso'
          );

          this.applyInputVolumeToCurrentStream();
        } else {
          console.warn('[UserAgent] Sender de áudio não encontrado');
        }
      } else {
        console.warn(
          '[UserAgent] Track de áudio não encontrado no novo stream'
        );
      }
    } catch (error) {
      console.error(
        '[UserAgent] Erro ao aplicar novo dispositivo de entrada:',
        error
      );
    }
  }

  async connect(
    ramal,
    secret,
    setReceivedInvitation,
    updateCallState,
    setDialpadOpen,
    onDisconnect
  ) {
    if (this.userAgent?.isConnected == true) return;

    const serviceBackEnd = new ServiceCRUDBACKEND();
    const response = await serviceBackEnd.getAgentStatusSoftphoneByRamal(ramal);
    const agentStatusSoftphone = response?.data?.data?.[0]

    if(agentStatusSoftphone &&agentStatusSoftphone?.agentLogin !== localStorage.getItem('login')){
      toast.warn('Este ramal já está sendo utilizado')
      localStorage.removeItem('softphone_user_session')
      return;
    }
    
    this.ramal = ramal;
    this.updateCallState = updateCallState;
    this.defean = false;
    this.mute = false;
    this.setDialpadOpen = setDialpadOpen;
    this.onDisconnect = onDisconnect;

    this.askNotificationPermission();

    this.userAgent = new UserAgent({
      uri: UserAgent.makeURI(`sip:${ramal}@${this.getDomain()}`),
      authorizationUsername: ramal,
      authorizationPassword: secret,
      displayName: localStorage.getItem('name'),
      sessionDescriptionHandlerFactoryOptions: {
        constraints: this.getMediaConstraints()
      },
      delegate: {
        onInvite: async (invitation) => {
          invitation.sessionType = 'Invitation';
          this.session = invitation;
          this.lostSession = true;
          let audio = new Audio(newCallAudio);

          this.applyOutputDeviceToElement(audio);
          audio.play();

          let intervalId = setInterval(async () => {
            await audio.play();
          }, 3000);

          setDialpadOpen(true);
          setReceivedInvitation(invitation);

          this.showNotification(
            `Você está recebendo uma ligação de: ${this.getSessionNumber()}`
          );

          invitation.stateChange.addListener((state) => {
            if (state == SessionState.Terminated) {
              this.closeLastNotification();
              if (this.lostSession === true) {
                this.showNotification(
                  `Ligação perdida de: ${this.getSessionNumber()}`
                );
              }
              this.clearSession();
            }

            updateCallState(state);
            this.callStateListener(state);

            if (state != SessionState.Initial) {
              this.setLostSessionAsFalse();
              this.closeLastNotification();
              clearInterval(intervalId);
              audio.pause();
              setReceivedInvitation(null);
            }
          });
        }
      },
      transportOptions: {
        server: `wss://${this.getDomainWithPort()}/ws`
      },
      logLevel: 'error'
    });

    await this.userAgent.start();

    const registerer = new Registerer(this.userAgent);

    registerer.stateChange.addListener(async (state) => {
      if (state == RegistererState.Registered) {
        this.updateCallState(SessionState.Initial);
        localStorage.setItem('softphone_ramal_session', ramal);
        localStorage.setItem(
          'softphone_user_session',
          localStorage.getItem('login')
        );
        await serviceBackEnd.registerAgentStatusSoftphone({
          agentLogin: localStorage.getItem('login'),
          agentCode: localStorage.getItem('agent_code'),
          extension: ramal,
          agentName: localStorage.getItem('name')
        });
      }
      if (state == RegistererState.Unregistered) {
        await this.disconnect(false);
      }
    });

    await registerer.register();
  }

  setLostSessionAsFalse() {
    this.lostSession = false;
  }

  showNotification(content) {
    if (Notification.permission === 'granted') {
      this.notification = new Notification('FlexUC', {
        body: content
      });
    }
  }

  closeLastNotification() {
    if (this.notification !== undefined) {
      this.notification.close();
    }
  }

  getSessionNumber() {
    let number = this.session?._dialog?.dialogState?.remoteURI?.normal?.user;

    if (number == undefined) {
      number = this.session?.outgoingRequestMessage?.toURI?.normal?.user;
    }
    return number ?? 'Desconhecido';
  }

  getSessionDisplayName() {
    let displayName =
      this.session?.incomingInviteRequest?.message?.from?._displayName;

    return displayName;
  }

  askNotificationPermission() {
    if (!('Notification' in window)) {
      console.log('Este navegador não suporta notificações de desktop.');
    } else if (Notification.permission === 'granted') {
      console.log('Permissão para notificações já foi concedida.');
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Permissão para notificações concedida.');
        }
      });
    }
  }

  async disconnect(isManual = false) {
    try {
      if (this.userAgent !== undefined) {
        await this.userAgent.stop();
        if (isManual) {
          localStorage.removeItem('softphone_ramal_session');
          localStorage.removeItem('softphone_user_session');

          const agentCode = localStorage.getItem('agent_code');
          if (agentCode) {
            const serviceBackEnd = new ServiceCRUDBACKEND();
            await serviceBackEnd.unregisterAgentStatusSoftphone(agentCode);
          }
        }
        this.userAgent = undefined;
        this.ramal = undefined;
        this.setLostSessionAsFalse();
        this.updateCallState(undefined);
        this.onDisconnect();
      }
    } catch (e) {
      console.log(e);
    }
  }

  getDomain() {
    let url =
      window.location.hostname == 'localhost'
        ? process.env.REACT_APP_PROXY_URL
        : window.location.origin;

    url = url.replace('http://', '');
    url = url.replace('https://', '');
    if (url.indexOf(':') != -1) {
      url = url.substring(0, url.indexOf(':'));
    }
    if (url.indexOf('/') != -1) {
      url = url.substring(0, url.indexOf('/'));
    }
    return url;
  }

  getDomainWithPort() {
    // Verifica se estamos em ambiente de desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      // Em ambiente de desenvolvimento, usa a URL do proxy ou 9090 como fallback
      const devUrl = process.env.REACT_APP_PROXY_URL || 'localhost:9090';
      // Remove http/https e barras para garantir o formato correto
      return devUrl.replace(/^(https?:\/\/)?(.*?\/.*)?$/, '$2').split('/')[0];
    } else {
      // Em produção, usa o hostname e a porta do window.location
      const port = window.location.port;
      if (port) {
        return `${window.location.hostname}:${port}`;
      } else {
        // Se a porta for vazia (porta padrão), retorna apenas o hostname
        return window.location.hostname;
      }
    }
  }

  setupRemoteMedia(session) {
    this.mediaElement = document.getElementById('mediaElement');
    const remoteStream = new MediaStream();
    if (session.sessionDescriptionHandler !== undefined) {
      session.sessionDescriptionHandler.peerConnection
        .getReceivers()
        .forEach((receiver) => {
          if (receiver.track) {
            remoteStream.addTrack(receiver.track);
          }
        });
      this.mediaElement.srcObject = remoteStream;

      this.applyOutputDeviceToElement(this.mediaElement).then(() => {
        this.mediaElement.volume = this.outputVolume;
        this.mediaElement.play();
      });
    }

    this.checkMedia();
  }

  cleanupMedia() {
    if (this.mediaElement) {
      this.mediaElement.srcObject = null;
      this.mediaElement.pause();
    }
  }

  callStateListener(state) {
    switch (state) {
      case SessionState.Established:
        this.setupRemoteMedia(this.session);
        break;
      case SessionState.Terminating:
      case SessionState.Terminated:
        this.cleanupMedia();
        break;
    }
  }

  async clearSession() {
    this.session = undefined;
    this.setLostSessionAsFalse();
    // Não chama updateCallState aqui para evitar conflitos
  }

  async call(phone) {
    try {
      if (this.isCallInProgress) {
        return;
      }

      if (!this.userAgent || !this.userAgent.isConnected) {
        toast.error(
          'Softphone não está conectado. Reconecte e tente novamente.',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      this.isCallInProgress = true;
      const uri = `sip:${phone}@${this.getDomain()}`;

      const inviter = new Inviter(this.userAgent, UserAgent.makeURI(uri), {
        params: { fromDisplayName: this.userAgent.displayName },
        sessionDescriptionHandlerOptions: {
          constraints: this.getMediaConstraints()
        }
      });
      inviter.sessionType = 'Inviter';
      this.session = inviter;

      let audio = new Audio(toneCallAudio);

      this.applyOutputDeviceToElement(audio);
      audio.play();
      let intervalId = setInterval(async () => {
        await audio.play();
      }, 5000);

      inviter.stateChange.addListener((state) => {
        this.callStateListener(state);
        if (state != SessionState.Establishing) {
          clearInterval(intervalId);
          audio.pause();
        }
        if (state == SessionState.Terminated) {
          this.clearSession();
          this.isCallInProgress = false;
          let audio = new Audio(endCallAudio);
          audio.play();
        }
        this.updateCallState(state);
      });
      await inviter.invite();
    } catch (e) {
      this.clearSession();
      this.isCallInProgress = false;
      this.updateCallState(SessionState.Initial);

      // Só mostra toast se não for um cancelamento intencional
      if (!e.message?.includes('cancel') && !e.message?.includes('Cancel')) {
        toast.error('Não foi possível realizar a ligação', {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    }
  }

  async sendDTMF(value) {
    if (this.session.state == 'Established') {
      const options = {
        requestOptions: {
          body: {
            contentDisposition: 'render',
            contentType: 'application/dtmf-relay',
            content: `Signal=${value}\r\nDuration=1000`
          }
        }
      };
      this.session.info(options);
    }
  }

  async blindedTransfer(ramal) {
    this.setDialpadOpen(true);
    const target = UserAgent.makeURI(`sip:${ramal}@${this.getDomain()}`);
    await this.session.refer(target);
    await this.endCall();
    toast.success('Ligação transferida');
  }

  async attendedTransfer(ramal) {
    this.setDialpadOpen(true);
    const transfer = ['*', '2', ...ramal.split('')];

    for (let dtmf of transfer) {
      const options = {
        requestOptions: {
          body: {
            contentDisposition: 'render',
            contentType: 'application/dtmf-relay',
            content: `Signal=${dtmf}\r\nDuration=1000`
          }
        }
      };
      await this.session.info(options);
    }

    toast.info('Transferindo ligação');
  }

  async toggleDefean() {
    const defean = this.defean ?? false;
    this.defean = !defean;
    this.checkMedia();
  }

  async toggleMute(mute) {
    this.mute = mute ?? !this.mute;
    this.checkMedia();
  }

  checkMedia() {
    if (this.session != undefined) {
      if (this.mediaElement != undefined) {
        if (this.defean) {
          this.mediaElement.pause();
        } else {
          this.mediaElement.play();
        }
      }

      const pc = this.session?.sessionDescriptionHandler?.peerConnection;
      if (pc != undefined) {
        pc.getSenders().forEach((stream) => {
          stream.track.enabled = !this.mute;
        });
      }
    }
  }

  async endCall() {
    if (!this.session) {
      return;
    }

    this.isCallInProgress = false;
    const endAudio = new Audio(endCallAudio);

    this.applyOutputDeviceToElement(endAudio);
    endAudio.play();

    try {
      switch (this.session.state) {
        case SessionState.Initial:
        case SessionState.Establishing:
          await this.session.cancel();
          break;
        case SessionState.Established:
          await this.session.bye();
          break;
        case SessionState.Terminating:
        case SessionState.Terminated:
          break;
      }
    } catch (error) {
      // Erros de encerramento são normais, não precisam ser logados
    } finally {
      this.clearSession();
      this.updateCallState(SessionState.Initial);
    }
  }
}

const userAgentSingleton = new UserAgentSingleton();
export default userAgentSingleton;
